<!--//track by index because there may be duplicate segments-->
<span *ngFor="let segment of segments();"
	[ngSwitch]="segment.match"><u *ngSwitchCase="true">{{segment.text}}</u><span *ngSwitchCase="false">{{segment.text}}</span></span>
